import React, { useEffect, useState, useContext } from "react";
import api from "../../services/api";
import { HeyatYoluContext } from "../../App";
import { FaUsers, FaFileAlt, FaRibbon, FaClock, FaChartLine } from "react-icons/fa";

function DashboardHome() {
  const { user } = useContext(HeyatYoluContext);
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [incomeData, setIncomeData] = useState(null);

  useEffect(() => {
    api.get("/admin/overview")
      .then(res => setOverview(res.data))
      .catch(err => console.error("Overview alınmadı:", err))
      .finally(() => setLoading(false));

    if (user?.role === "admin") {
      api.get("/admin/income-summary")
        .then(res => setIncomeData(res.data))
        .catch(err => console.error("Gəlir məlumatı alınmadı:", err));
    }
  }, [user]);

  if (loading) {
    return (
      <div className="hy-dash-home-loading">
        <div className="hy-dash-home-spinner" />
        <p>Yüklənir...</p>
      </div>
    );
  }

  if (!overview) {
    return (
      <div className="hy-dash-home-error">
        <span className="hy-dash-home-error-icon">⚠️</span>
        <p>Məlumat tapılmadı</p>
      </div>
    );
  }

  const stats = [
    { icon: <FaUsers />, label: "Toplam İstifadəçi", value: overview.userCount, color: "#6366f1" },
    { icon: <FaFileAlt />, label: "Postlar", value: overview.profileCount, color: "#8b5cf6" },
    { icon: <FaRibbon />, label: "Şəhid Postları", value: overview.martyrCount, color: "#ec4899" },
    { icon: <FaClock />, label: "Gözləyən", value: overview.pendingProfiles, color: "#f59e0b" },
  ];

  return (
    <div className="hy-dash-home-container">
      <div className="hy-dash-home-header">
        <h2 className="hy-dash-home-title">
          <FaChartLine /> Panel Xülasəsi
        </h2>
        <p className="hy-dash-home-subtitle">Sistemin ümumi statistikası</p>
      </div>

      <div className="hy-dash-home-stats-grid">
        {stats.map((stat, index) => (
          <div 
            key={index} 
            className="hy-dash-home-stat-card"
            style={{ '--card-color': stat.color }}
          >
            <div className="hy-dash-home-stat-icon">{stat.icon}</div>
            <div className="hy-dash-home-stat-content">
              <p className="hy-dash-home-stat-label">{stat.label}</p>
              <h3 className="hy-dash-home-stat-value">{stat.value}</h3>
            </div>
            <div className="hy-dash-home-stat-bg" />
          </div>
        ))}
      </div>

      {user?.role === "admin" && incomeData && (
        <div className="hy-dash-home-income-section">
          <div className="hy-dash-home-income-header">
            <h3 className="hy-dash-home-section-title">
              💰 Gəlir Xülasəsi
            </h3>
          </div>
          
          <div className="hy-dash-home-income-card">
            <div className="hy-dash-home-total-income">
              <span className="hy-dash-home-income-label">Toplam Gəlir</span>
              <span className="hy-dash-home-income-value">
                {incomeData.totalIncome.toFixed(2)} <span className="hy-dash-home-currency">AZN</span>
              </span>
            </div>
          </div>

          <div className="hy-dash-home-table-wrapper">
            <table className="hy-dash-home-income-table">
              <thead>
                <tr>
                  <th>Tarix</th>
                  <th>Əməliyyat Sayı</th>
                  <th>Gəlir (AZN)</th>
                </tr>
              </thead>
              <tbody>
                {incomeData.incomeByDate.slice(0, 10).map((item, i) => (
                  <tr key={i}>
                    <td>{new Date(item.date).toLocaleDateString('az-AZ')}</td>
                    <td>
                      <span className="hy-dash-home-count-badge">{item.count || '-'}</span>
                    </td>
                    <td>
                      <span className="hy-dash-home-amount">{item.total.toFixed(2)}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="hy-dash-home-tables-grid">
        <div className="hy-dash-home-table-section">
          <h3 className="hy-dash-home-section-title">
            🆕 Son 5 Qeydiyyat
          </h3>
          <div className="hy-dash-home-table-wrapper">
            <table className="hy-dash-home-data-table">
              <thead>
                <tr>
                  <th>Ad</th>
                  <th>Email</th>
                  <th>Tarix</th>
                </tr>
              </thead>
              <tbody>
                {overview.last5Users.map((u, i) => (
                  <tr key={i}>
                    <td>{u.fullName}</td>
                    <td className="hy-dash-home-email">{u.email}</td>
                    <td>{new Date(u.createdAt).toLocaleDateString('az-AZ')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="hy-dash-home-table-section">
          <h3 className="hy-dash-home-section-title">
            🖼️ Son 5 Post
          </h3>
          <div className="hy-dash-home-table-wrapper">
            <table className="hy-dash-home-data-table">
              <thead>
                <tr>
                  <th>Ad</th>
                  <th>Soyad</th>
                  <th>Vəfat</th>
                </tr>
              </thead>
              <tbody>
                {overview.last5Profiles.map((p, i) => (
                  <tr key={i}>
                    <td>{p.firstName}</td>
                    <td>{p.lastName}</td>
                    <td>{new Date(p.dateOfDeath).toLocaleDateString('az-AZ')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardHome;